export const getters = {
  insurance: state => state.insurance,
  insurances: state => state.insurances
}

const GET_INSURANCES = 'insurance/insurances'

export const gettersTypes = {
  GET_INSURANCES
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/insurance/getters.js